import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import {
  AFFILIATE_REFERENCE_CONDITION_ROUTE_NAME,
  AFFILIATE_REFERENCE_LINK_ROUTE_NAME,
  AFFILIATE_REFERENCE_PERMISSIONS,
  AFFILIATE_REFERENCE_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_REFERENCE,
} from '@modules/affiliate-reference/constants';
import { getTranslationKeys } from '@modules/affiliate-reference/translations';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  AFFILIATE_TRACKING_LINKS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

export class AffiliateReferenceModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAffiliateRoute({
      name: AFFILIATE_REFERENCE_ROUTE_NAME,
      path: 'affiliate-reference',
      permission: AFFILIATE_REFERENCE_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffiliateReferencePage',
    });

    router.addChildRoute(AFFILIATE_REFERENCE_ROUTE_NAME, {
      name: AFFILIATE_REFERENCE_LINK_ROUTE_NAME,
      path: '',
      permission: AFFILIATE_REFERENCE_PERMISSIONS.SHOW,
      component: () => import('@modules/affiliate-reference/pages/AffiliateReferencePage/AffiliateReferencePage.vue'),
    });

    router.addChildRoute(AFFILIATE_REFERENCE_ROUTE_NAME, {
      name: AFFILIATE_REFERENCE_CONDITION_ROUTE_NAME,
      path: 'subaffiliate-condition',
      permission: AFFILIATE_REFERENCE_PERMISSIONS.SHOW,
      component: () => import('@modules/affiliate-reference/pages/AffiliateReferenceConditionPage/AffiliateReferenceConditionPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAffiliateMenuItem(AFFILIATE_TRACKING_LINKS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'TRACKING_LINKS_REGISTRATION_REFERENCE'),
      to: {
        name: AFFILIATE_REFERENCE_LINK_ROUTE_NAME,
      },
      permission: AFFILIATE_REFERENCE_PERMISSIONS.SHOW,
      id: AFFILIATE_REFERENCE_LINK_ROUTE_NAME,
      order: 50,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_REFERENCE, getTranslationKeys);
  }
}
